/**
 * EP P2P trading hall access — A3+ only (see + buy + sell).
 * Hall browse / new sell / new buy only during Beijing 9:00–11:00 and 13:30–15:30.
 */
import { isLevelGte } from './levels.js';

/** Minimum membership level to view / trade in the EP hall. */
export const EP_TRADE_MIN_LEVEL = 'A3';

/** Beijing time. Inclusive start, exclusive end (11:00 and 15:30 are closed). */
export const EP_TRADE_TZ = 'Asia/Shanghai';
export const EP_TRADE_WINDOWS_MINUTES = [
  { start: 9 * 60, end: 11 * 60 },
  { start: 13 * 60 + 30, end: 15 * 60 + 30 },
] as const;

export function shanghaiMinutesSinceMidnight(at: Date = new Date()): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: EP_TRADE_TZ,
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
  }).formatToParts(at);
  const hour = Number(parts.find((p) => p.type === 'hour')?.value ?? '0');
  const minute = Number(parts.find((p) => p.type === 'minute')?.value ?? '0');
  return hour * 60 + minute;
}

export function isEpTradingWindowOpen(at: Date = new Date()): boolean {
  const m = shanghaiMinutesSinceMidnight(at);
  return EP_TRADE_WINDOWS_MINUTES.some((w) => m >= w.start && m < w.end);
}

/** Public hang-list / orderbook (not my-sell, my-buy, or dispute). */
export function isEpHallBrowseQuery(input: {
  seller_id?: number;
  buyer_id?: number;
  status?: string;
}): boolean {
  if (input.seller_id != null || input.buyer_id != null) return false;
  if (input.status && input.status !== 'open') return false;
  return true;
}

export function qualifiesForEpTrade(levelCode: string): boolean {
  return isLevelGte(levelCode, EP_TRADE_MIN_LEVEL);
}

/** Prefer 服务级 (reward_level); fall back to users.level_code. */
export function qualifiesForEpTradeProfile(input: {
  level_code?: string | null;
  reward_level_code?: string | null;
}): boolean {
  const reward = input.reward_level_code?.trim();
  if (reward) return qualifiesForEpTrade(reward);
  const userLevel = input.level_code?.trim();
  return userLevel ? qualifiesForEpTrade(userLevel) : false;
}
